import React, {Component} from 'react';
import {Form, Input} from 'semantic-ui-react';
import {connect} from 'react-redux';
import {enterKeyCode, tabKeyCode} from '../../../common/constants/keyCodes';
import {Actions} from '../../../common/actions';

class PrincipalPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'usePrincipalPart': false,
      'principalPart': props.principalPart,
    };
  }

  componentDidUpdate() {
    const {usePrincipalPart, principalPart} = this.state;
    const {handleChange, part} = this.props;

    if (usePrincipalPart && principalPart !== part.code) {
      handleChange('principalPartDescription', part.name);
      this.setState({
        'usePrincipalPart': false,
        'principalPart': part.code,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearSearchPartWarranty();
  }

  handleKeyDown = (e) => {
    const {principalPart} = this.props;
    if (e.keyCode === enterKeyCode || e.keyCode === tabKeyCode) {
      if (principalPart.length > 1) {
        this.setState({
          'usePrincipalPart': true,
        });
        this.props.getWarrantyPart(principalPart);
      }
      e.preventDefault();
    }
  }

  render() {
    const {handleSearchPart, principalPart, principalPartDescription, disabledBtns} = this.props;

    return (
      <Form.Group widths='three'>
        <Form.Field
          disabled={disabledBtns}
          value={principalPart || ''}
          control={Input}
          label='OFP Parte Principal'
          placeholder='OFP Parte Principal'
          onKeyDown={this.handleKeyDown}
          onChange={(e, {value}) => handleSearchPart(value)}
        />

        <Form.Field
          value={principalPartDescription}
          control={Input}
          label='Descripción'
          placeholder='Descripción'
          disabled={true}
        />
      </Form.Group>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loading': state.warrantiesCategories.loading,
    'part': state.warrantiesCategories.part,
  };
};

const {getWarrantyPart, clearSearchPartWarranty} = Actions;

export default connect(mapStateToProps, {
  getWarrantyPart,
  clearSearchPartWarranty,
})(PrincipalPart);

